@let sp_me = player.media_event;
@let sp_game = sp_me && sp_me.game;
@let sp_flavor = player.flavor;

<header>
	<div class="current-playback" *ngIf="sp_me && sp_flavor" (click)="toggle_overlay('flavor-selector')">
		<i class="material-icons">tune</i>
		<span class="flavor">{{ sp_flavor.name }}</span>
		<span class="title">
			<i class="material-icons">play_arrow</i>
			{{ sp_me.title }}
		</span>
	</div>

	<button class="events-toggle" (click)="toggle_overlay('events-selector')">
		<span>Select Game</span>
		<i class="material-icons" [class.closed]="current_overlay=='events-selector'">
			<span class="open">expand_more</span>
			<span class="close">close</span>
		</i>
	</button>
</header>
<div class="screen">

	<app-poster
		class="overlay poster"
		[class.shown]="current_overlay=='poster'"
		(close)="close_overlay('poster')"
		(open)="select_overlay('poster')"/>

	<div class="overlay events-selector" [class.shown]="current_overlay=='events-selector'">
		<header>
			<div class="line"></div>
			<div class="button-group">
				<span>Filters</span>
				<button [class.active]="show_replay_media_events" (click)="show_replay_media_events = !show_replay_media_events">
					<i class="material-icons">calendar_month</i>
					Replay
					<div class="dot"></div>
				</button>
				<button [class.active]="show_live_media_events" (click)="show_live_media_events = !show_live_media_events">
					<i class="material-icons">today</i>
					Live
					<div class="dot"></div>
				</button>
				<button [class.active]="show_planned_media_events" (click)="show_planned_media_events = !show_planned_media_events">
					<i class="material-icons">event</i>
					Planned
					<div class="dot"></div>
				</button>
			</div>
			<div class="line"></div>
		</header>

		<div class="events">
			@for( e of events; track e.type + e.id ){

				@if( e.type == 'Game' ){
					@let status = game_id_to_prominent_media_status[e.id];
					<div class="event game" [class.live]="status == 'L'" *ngIf="show_media_events_with_status( status )">

						@for( t of e.teams; track t.id; let idx = $index ){
							<app-team [team]="t" [score]="idx ? e.home_score : e.away_score" [is_spoilable]="e.is_spoilable()"/>
						}

						<span class="datetime">
							<span class="date">
								{{ e.datetime | tzdate:'MMM dd' }}
							</span>
							<span class="time">{{ e.datetime | tzdate:'HH:mm (TT)' }}</span>
						</span>

						<span class="feeds">
							@for( me of game_id_to_media_events[e.id]; track me.id ){
								@let feed_is_me = sp_me && me.id == sp_me.id;
								<span class="feed" *ngIf="show_media_events_with_status( me.status )"
									[class]="me.get_status_display().toLowerCase()" [class.playing]="feed_is_me" (click)="selectFeed(me)">

									@let stars = me.get_team_stars();
									@if( stars ){
										<span class="stars">
											<i *ngFor="let count of stars | range" class="material-icons">star</i>
										</span>
									}
									<i *ngIf="feed_is_me" class="material-icons playing">play_arrow</i>
									<i *ngIf="!media_event_id_public.has(me.id) && media_event_id_to_flavors[me.id].length" class="material-icons premium">workspace_premium</i>
									{{ me.title }}
								</span>
							}
						</span>

						<button *ngIf="status != 'P'"
							class="play"
							[class.live]="status == 'L'"
							[class.playing]="sp_game && e.id == sp_game.id"
							(click)="selectFirstFeed(e)">
							<i class="material-icons">{{ 'LO'.includes(status) ? 'play_arrow' : 'history' }}</i>
						</button>
					</div>
				} @else {
					<div class="event custom"
						[class.redzone]="e.title=='RedZone'"
						(click)="selectFeed(e)"
						*ngIf="show_media_events_with_status( e.status )">

						@if( e.title == 'RedZone' ){
							<img class="logo" src="/assets/official-logos/nfl-redzone-text.svg" alt=""/>
						}

						<span class="datetime">
							<span class="date">
								{{ e.datetime | tzdate:'MMM dd' }}
							</span>
							<span class="time">{{ e.datetime | tzdate:'HH:mm (TT)' }}</span>
						</span>

						<span class="feeds">
							@let feed_is_me = sp_me && e.id == sp_me.id;
							<span class="feed" [class]="e.get_status_display().toLowerCase()" [class.playing]="feed_is_me" (click)="selectFeed(e)">
								<i *ngIf="feed_is_me" class="material-icons playing">play_arrow</i>
								<i *ngIf="!media_event_id_public.has(e.id) && media_event_id_to_flavors[e.id].length" class="material-icons premium">workspace_premium</i>
								{{ e.title }}
							</span>
						</span>

						<button *ngIf="e.status != 'P'"
							class="play"
							[class.live]="e.status == 'L'"
							[class.playing]="sp_me && e.id == sp_me.id"
							(click)="selectFeed(e)">
							<i class="material-icons">{{ 'LO'.includes(e.status) ? 'play_arrow' : 'history' }}</i>
						</button>
					</div>
				}

			}
		</div>

	</div>

	<div class="overlay flavor-selector" [class.shown]="current_overlay=='flavor-selector'" *ngIf="sp_me">
		<header>More Source Options:</header>
		@for( flavor of media_event_id_to_flavors[sp_me.id]; track flavor.id ){
			@let current = flavor.id == sp_flavor.id;
			<div class="flavor" [class.current]="current" (click)="selectFeed(sp_me, flavor)">
				@if( !flavor.is_public && !profile.is_premium ){
					<i class="checkbox material-icons">lock</i>
				} @else if( current ) {
					<i class="checkbox material-icons">radio_button_checked</i>
				} @else {
					<i class="checkbox material-icons">radio_button_unchecked</i>
				}

				<span class="name">{{ flavor.name }}</span>
				<i class="tag premium material-icons" *ngIf="!flavor.is_public">workspace_premium</i>
			</div>
		}
		<div class="admin-panel" *ngIf="sp_me && sp_flavor && profile.chat_user && profile.chat_user.role=='admin'">
			<header>Admin Tools:</header>
			<p>
				Press the button below, To reload every <b>Distributor</b><br/>
				of the flavor ({{ sp_flavor.name }}) for this ({{ sp_me.title }}) feed.<br/>
				<small>This action should have no noticable downsides, unless we're at peak demand hours.</small>
				<button (click)="adminAction( sp_me.id, sp_flavor.id, 'reload-distributors', $event )">Reload Distributors</button>
			</p>
			<p>
				Press the button below, To restart the <b>Watch job</b> of the current media.<br/>
				<small>This action should only briefly interrupt the current ({{ sp_me.title }}) feed.</small><br/>
				<button class="warn" (click)="adminAction( sp_me.id, sp_flavor.id, 'restart-watch-job', $event )">Restart Watch Job</button>
			</p>

		</div>

	</div>

	<div class="overlay players-setup" [class.shown]="current_overlay=='players-setup'">
		<div class="player-selects button-group">
			<span>Player</span>
			<button [class.active]="settings.player_type == 'clappr'" (click)="change_player_type('clappr')">
				<i class="material-icons">movie</i>
				Clappr
				<div class="dot"></div>
			</button>
			<button [class.active]="settings.player_type == 'shaka'" (click)="change_player_type('shaka')">
				<i class="material-icons">play_arrow</i>
				Shaka
				<div class="dot"></div>
			</button>
			<!--button [class.active]="settings.player_type == 'tv24all'" (click)="change_player_type('tv24all')">
				TV24ALL
				<i class="material-icons">cast</i>
			</button-->
		</div>

		<div class="layout-select">
			<div class="layout" [class.active]="settings.player_layout=='single'" (click)="change_player_layout('single')">
				<div class="box single">
					<span><i class="material-icons">play_arrow</i></span>
				</div>
				<span>Single Screen</span>
			</div>
			<div class="layout" [class.active]="settings.player_layout=='quad'" (click)="change_player_layout('quad')">
				<i class="material-icons tag premium">workspace_premium</i>
				<i class="material-icons tag locked" *ngIf="!profile.is_premium">lock</i>
				<div class="box quad">
					<span><i class="material-icons">play_arrow</i></span>
					<span><i class="material-icons">play_arrow</i></span>
					<span><i class="material-icons">play_arrow</i></span>
					<span><i class="material-icons">play_arrow</i></span>
				</div>
				<span>Quad Screen</span>
			</div>
		</div>
	</div>

	<div class="players" [class]="settings.player_layout">
		@for( pid of player_ids; track pid ){
			<app-player [id]="pid" [class.selected]="player.selected_player_id == pid"
				(click)="player.select(pid)"/>
		}
	</div>

</div>
<footer>

	<button class="layout" (click)="toggle_overlay('players-setup')">
		<i class="material-icons">aspect_ratio</i>
	</button>
	<div class="vertical-line"></div>

	<div class="event game" *ngIf="sp_game">
		@for( t of sp_game.teams; track t.id; let idx = $index ){
			<app-team [team]="t" [score]="idx ? sp_game.home_score : sp_game.away_score" [is_spoilable]="sp_game.is_spoilable()"/>
		}
	</div>

	@if( sp_me ){
		@switch (sp_me.provider){
			@case("SPORTSNET"){ <div class="provider sn" (click)="player._sp.clappr_player.seek(5860)"><img src="/assets/logo/sportsnet.svg" alt=""/></div> }
			@case("ESPN")     { <div class="provider espn"><img src="/assets/logo/espn-plus.svg" alt=""/></div> }
			@case("NFL")     { <div class="provider nfl"><img src="/assets/logo/nfl.svg" alt=""/></div> }
			@case("NBA")     { <div class="provider nba"><img src="/assets/logo/nba.svg" alt=""/></div> }
		}
	}

	<button class="show-paywall" (click)="core.events.emit('paywall')" *ngIf="!profile.is_premium">
		<span>Switch To</span>
		<img class="icon" src="/assets/hd-icon.svg" alt=""/>
		<span>60FPS</span>
	</button>



	<button class="control cast"
		[class.disabled]="!player.tv24all_url"
		(click)="cast_to_tv24all()">
		<i class="material-icons">cast</i>
	</button>
	<button class="control stop" (click)="player.stop()">
		<i class="material-icons">stop</i>
	</button>

</footer>
